;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();type CohortLike = {
  consultRequired?: boolean | null
}

const isConsultRequired = (cohort: CohortLike | null | undefined): boolean => {
  return Boolean(cohort?.consultRequired)
}

export default isConsultRequired
